module.exports = __webpack_public_path__ + "img/4.52ee9f54.jpg";